export default "__VITE_ASSET__eRuGex1$__"